import { createRoot } from "react-dom/client";
import Main from "./Main";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/custom.css";
import { UsernameProvider } from "./contexts/user";
import { SatelliteProvider } from "./contexts/SatelliteContext";
import { SewProvider } from "./contexts/SewContext";
import { Helmet } from "react-helmet";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <>
        <Helmet>
            <meta name="description" content="PROBE: A comprehensive database of satellite information." />
        </Helmet>
        <UsernameProvider>
            <SatelliteProvider>
                <SewProvider>
                    <Main />
                </SewProvider>
            </SatelliteProvider>
        </UsernameProvider>
    </>
);
